import { z } from "zod";
import { baseHeaderSchema } from "./base-definition";

export const rowExpresssionSchema = baseHeaderSchema.extend({
  type: z.literal("row-expression"),
  expression: z.string(),
});

export type RowExpressionType = z.infer<typeof rowExpresssionSchema>;
